import React from 'react';

import { Helmet } from 'react-helmet';

import { Container, Row, Col } from 'reactstrap';

import { receiveProducts } from '@ttstr/actions';
import { useIntl, ContentrArea } from '@ttstr/components';

import { AppState } from '@ttstr/reducers';
import { useActions, useShallowEqualSelector } from '@ttstr/utils';
import FilteredMasonry from './FilteredMasonry';

const AlgSampler: React.FC = () => {
  const { products } = useShallowEqualSelector(mapStateToProps);
  const { receiveProducts } = useActions(mapDispatchToProps);
  const { language } = useIntl();

  React.useEffect(() => {
    const abortController = new AbortController();
    receiveProducts(undefined, { signal: abortController.signal });
    return () => abortController.abort();
  }, [language]);

  return (
    <article className="my-5">
      <Container>
        <Helmet>
          <title>ANTILOPEN GELDWÄSCHE SAMPLER 1 - Jetzt vorbestellen</title>
          <body className="alg-page inverse-navbar" />
        </Helmet>
        <Container>
          <Row className="mt-4">
            <Col md="12">
              <h1 className="text-center">
                ANTILOPEN
                <br />
                GELDWÄSCHE
                <br />
                SAMPLER 1
                <small className="mt-2">
                  24.12.2021
                  <br />
                  CD / VINYL / DIGITAL
                </small>
              </h1>
            </Col>
          </Row>
        </Container>
        <FilteredMasonry
          className="mt-5"
          id="product-listing"
          // type={Maki2020}
          products={products}
          filters="off"
          tagId={4888}
          columnClassName="col-md-6 col-lg-6"
          showSubtitle
          // itemClassName="random-rotation-object"
          // itemImageClassName="scribble-hover-overlay-object"
        />
        <ContentrArea id="shipping-and-refund-main" />
      </Container>
    </article>
  );
};

const mapStateToProps = (state: AppState) => {
  const { products, loading } = state.Products;
  return {
    products,
    loading,
  };
};

const mapDispatchToProps = {
  receiveProducts,
};

export default React.memo(AlgSampler);
